<!--
 * @Description: 维修、重装、拆卸任务项列表
 * @Author: ChenXueLin
 * @Date: 2021-11-18 15:23:56
 * @LastEditTime: 2023-03-20 17:20:39
 * @LastEditors: ChenXueLin
-->
<template>
  <!-- 任务项 start -->
  <div
    class="task-list-content"
    :element-loading-background="loadingBackground"
    v-loading="loading"
  >
    <detail-table-title>
      <template v-slot:title>
        任务项
      </template>
      <template v-slot:btns>
        <!-- <el-button
          style="margin-left:5px;"
          type="primary"
          @click="handleCombination"
          v-if="basicInfo.taskSource == 3"
        >
          维护物料和组合
        </el-button> -->
        <!-- <el-button
          style="margin-left:5px;"
          type="primary"
          @click="changeMaterial"
          v-if="basicInfo.taskSource == 3"
        >
          选择物料
        </el-button> -->

        <el-button
            style="margin-left:5px;"
            type="primary"
            @click="openAssignReason"
            v-if="
            (basicInfo.taskSource == 3 || basicInfo.taskSource == 5) &&
              [2].includes(basicInfo.taskFirstClass)
          "
        >
          派单原因
        </el-button>

        <el-button
          style="margin-left:5px;"
          type="primary"
          @click="addDispatch"
          v-has="UNDEFINED_5_BUTTON_ID"
          >创建调度任务</el-button
        >
        <el-button
          type="primary"
          @click="changeEngineer('assgin')"
          v-has="APPROVE_BUTTON_ID"
          style="margin-left:5px;"
        >
          指派工程师
        </el-button>
        <el-button
          type="primary"
          @click="changeEngineer('change')"
          v-has="MAINTENANCE_CHANGE_SAME_CLASS_EQUIPMENT_BUTTON_ID"
          style="margin-left:5px;"
        >
          更换工程师
        </el-button>
        <el-button
          type="primary"
          @click="handleItem(1)"
          style="margin-left:5px;"
        >
          撤回任务项
        </el-button>
        <el-button
          type="primary"
          @click="handleItem(2)"
          style="margin-left:5px;"
          v-has="136"
        >
          关闭任务项
        </el-button>
        <!-- <el-button
          type="primary"
          @click="handleItem(3)"
          style="margin-left:5px;"
        >
          改约
        </el-button> -->
      </template>
      <template v-slot:searchForm>
        <el-form class="search-list" ref="searchForm" :model="searchForm">
          <el-form-item class="search-item--1" prop="itemIdList">
            <input-plus
              v-model="searchForm.itemIdList"
              valueType="Array"
              placeholder="工单ID"
              title="工单ID"
              label="工单ID"
              clearable
            ></input-plus>
          </el-form-item>
          <el-form-item class="search-item--1" prop="sceneName">
            <el-input
              placeholder="场景名称"
              title="场景名称"
              v-model="searchForm.sceneName"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item--1" prop="sceneType">
            <e6-vr-select
              v-model="searchForm.sceneType"
              :data="sceneTypeList"
              placeholder="场景类型"
              title="场景类型"
              clearable
              :props="{
                id: 'codeValue',
                label: 'codeName'
              }"
            ></e6-vr-select>
          </el-form-item>
          <el-form-item class="search-item--1" prop="engineerrpName">
            <el-input
              placeholder="工程师"
              title="工程师"
              v-model="searchForm.engineerrpName"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item--1" prop="engineerrpPhone">
            <el-input
              placeholder="工程师电话"
              title="工程师电话"
              v-model="searchForm.engineerrpPhone"
            ></el-input>
          </el-form-item>

          <el-form-item class="search-item--1" prop="contactName">
            <el-input
              placeholder="第二联系人"
              title="第二联系人"
              v-model="searchForm.contactName"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item--1" prop="contactPhone">
            <el-input
              placeholder="第二联系人电话"
              title="第二联系人电话"
              v-model="searchForm.contactPhone"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item--1" prop="address">
            <el-input
              placeholder="安装地址"
              title="安装地址"
              v-model="searchForm.address"
            ></el-input>
          </el-form-item>
          <el-form-item class="search-item--buttons">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button class="reset" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
    </detail-table-title>
    <div class="switch-page-button">
      <el-button
        round
        :class="[clickIndex == index ? 'activeButton' : '']"
        v-for="(btn, index) in btnList"
        :key="index"
        @click="switchPage(index, btn.statusNameCode)"
        >{{ btn.statusName }}{{ btn.count }}</el-button
      >
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      height="300px"
      header-row-class-name="table-header"
      @expand-change="rowExpand"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
      @selection-change="handleSelectionChange"
      @select-all="selectAll"
      ref="multipleTable"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
        fixed
      ></el-table-column>
      <!-- 展开行内容 -->
      <el-table-column type="expand">
        <!--  eslint-disable-next-line -->
        <template slot-scope="scope">
          <el-table
            v-loading="childListLoading"
            :data="childTableData"
            border
            style="width: 900px;margin-left:80px;"
            height="200"
          >
            <el-table-column
              show-overflow-tooltip
              v-for="(column, index) in expandedColumn"
              :key="index"
              :prop="column.fieldName"
              :label="column.fieldLabel"
              :min-width="column.width"
              :fixed="column.fixed"
              :align="column.align"
              header-align="center"
            >
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        v-for="(column, index) in columnData"
        :key="index"
        :prop="column.fieldName"
        :label="column.fieldLabel"
        :min-width="column.width"
        :fixed="column.fixed"
        :align="column.align"
        header-align="center"
      >
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="180">
        <template slot-scope="scope">
          <e6-td-operate
            :data="getOperateList(scope.row)"
            @command="handleOperate($event, scope.row)"
          ></e6-td-operate>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 start -->
    <section class="pagination-wrapper fixed-section">
      <el-pagination
        :page-size.sync="searchForm.pageSize"
        :current-page.sync="searchForm.pageIndex"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="total"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </section>
    <!-- 分页 end -->
    <!-- 选择物料 -->
    <change-material
      @handleClose="handleClose"
      :taskId="taskId"
      :changeMaterialVisible="changeMaterialVisible"
      :isGrayscaleWork="basicInfo.isGrayscaleWork"
      @refresh="getStatus"
      :itemIdList="itemIdList"
    ></change-material>
    <!-- 创建调度单弹框   -->
    <create-dispatch
      :createDispatchDialog="createDispatchDialog"
      @handleClose="handleClose"
      @refresh="getStatus"
      :taskId="taskId"
      :basicInfo="basicInfo"
      :itemIdList="itemIdList"
      :itemList="itemList"
      :customerId="customerId"
    ></create-dispatch>
    <!-- 更换/指派工程师 -->
    <change-engineer
      :isChange="isChange"
      :changeType="changeType"
      @handleClose="handleClose"
      @refresh="getStatus"
      :basicInfo="basicInfo"
      :taskId="taskId"
      :customerId="customerId"
      :itemIdList="itemIdList"
      :itemList="itemList"
    ></change-engineer>
    <!-- 查看已安装设备弹框 -->
    <installed-devices
      :showEquipVisible="showEquipVisible"
      @handleClose="closeDialog"
    ></installed-devices>
    <!-- 改约弹框 -->
    <change-time
      :changeTimeDialog="changeTimeDialog"
      @handleClose="handleClose"
      @updateItemInfo="updateItemInfo"
      :itemIdList="itemIdList"
    ></change-time>
    <!-- 维护物料和组合 -->
    <material-combination
      :materialCombinationVisible="materialCombinationVisible"
      @handleClose="handleClose"
      :isDeliverInstall="basicInfo.isDeliverInstall"
      :taskSource="basicInfo.taskSource"
      :taskId="taskId"
    ></material-combination>


    <assign-reason
        :assignReasonVisible="assignReasonVisible"
        @handleClose="handleClose"
        @refresh="getStatus"
        :itemIdList="itemIdList"
    ></assign-reason>
    <!-- 关闭任务项 -->
    <close-task-item-dialog
      :closeTaskItemDialog="closeTaskItemDialog"
      @handleClose="handleClose"
      @refresh="getStatus"
      dialogType="1"
      :itemIdList="itemIdList"
    ></close-task-item-dialog>
    <!-- 撤回任务项 -->
    <reason-write
      :batchReturnItemDialog="batchReturnItemDialog"
      @handleClose="handleClose"
      @refresh="getStatus"
      :itemIdList="itemIdList"
    ></reason-write>
  </div>
</template>

<script>
import changeMaterial from "../../components/changeMaterial.vue";
import taskDetail from "@/mixins/taskDetail";
import setting from "@/setting";
import index from "./index.js";
import reasonWrite from "@/components/workOrderManage/reasonWrite.vue";
import inputPlus from "@/components/inputPlus";
let {
  UNDEFINED_5_BUTTON_ID,
  APPROVE_BUTTON_ID,
  MAINTENANCE_CHANGE_SAME_CLASS_EQUIPMENT_BUTTON_ID
} = setting;
import {
  getRepairActionItem,
  getRemoveTaskActionItem,
  findDownList,
  getStatus,
  getReinstallActionItem
} from "@/api";
import { printError } from "@/utils/util";
import DetailTableTitle from "@/components/detailTableTitle.vue";
import changeTime from "@/components/changeTime.vue";
import {
  repairColumn,
  reinstallColumn,
  removeColumn
} from "../../tableColumnData";
import createDispatch from "../../components/createDispatch.vue";
import ChangeEngineer from "../../components/changeEngineer.vue";
import InstalledDevices from "@/components/workOrderManage/installedDevices.vue";
import MaterialCombination from "../../components/materialCombination.vue";
import closeTaskItemDialog from "@/components/workOrderManage/closeTaskItemDialog.vue";
import assignReason from "../../components/assignReasonDialog.vue";
export default {
  name: "maintain",
  components: {
    closeTaskItemDialog,
    DetailTableTitle,
    createDispatch,
    ChangeEngineer,
    InstalledDevices,
    changeTime,
    changeMaterial,
    MaterialCombination,
    reasonWrite,
    inputPlus,
    assignReason
  },
  data() {
    return {
      UNDEFINED_5_BUTTON_ID,
      APPROVE_BUTTON_ID,
      MAINTENANCE_CHANGE_SAME_CLASS_EQUIPMENT_BUTTON_ID,
      loading: false,
      clickIndex: 0,
      tableData: [], //
      searchForm: {
        itemIdList: [],
        itemStatus: "", //任务项状态
        sceneName: "", //场景名称
        sceneType: "", //场景类型
        engineerrpName: "", //工程师名称
        engineerrpPhone: "", //工程师电话
        contactPhone: "", //联系人电话
        contactName: "", //联系人名称
        address: "", //安装地址
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      sceneTypeList: [],
      contactList: [], //联系人下拉框
      engineerList: [], //工程师列表下拉框
      showEquipVisible: false, //是否查看已安装设备
      changeMaterialVisible: false
    };
  },
  //任务单ID,客户ID,任务单类型10维修单,3重装单,5:拆卸单
  props: ["taskId", "customerId", "taskType", "basicInfo"],
  mixins: [taskDetail, index],
  computed: {
    columnData() {
      let column = [];
      if (this.taskType == 10) {
        //维修
        column = repairColumn;
      } else if (this.taskType == 3) {
        //重装
        column = reinstallColumn;
      } else if (this.taskType == 12) {
        //拆卸
        column = removeColumn;
      }
      return column;
    }
  },
  watch: {},
  created() {
    this.getStatus();
    this.getData();
    this.initData();
  },
  methods: {
    updateItem() {
      this.getStatus();
    },
    // 初始化数据(获取表头,表格数据)
    async initData() {
      try {
        this.selectLoading = true;
        let promiseList = [findDownList(["sceneType"])];
        let [taskTypeRes] = await Promise.all(promiseList);
        //场景类型下拉框
        this.sceneTypeList = this.getFreezeResponse(taskTypeRes, {
          path: "data.sceneType"
        });
      } catch (error) {
        printError(error);
      } finally {
        this.selectLoading = false;
      }
    },
    //获取状态列表
    async getStatus() {
      try {
        let res = await getStatus({
          taskId: this.taskId
        });
        //基本信息
        this.btnList = this.getFreezeResponse(res, {
          path: "data"
        });
        this.searchForm.itemStatus =
          this.btnList && this.btnList.length
            ? this.btnList[0].statusNameCode
            : "";
        this.getActionItem();
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    getRowKey(row) {
      return row.itemId;
    },
    // 页码改变
    handleCurrentChange(curPage) {
      this.searchForm.pageIndex = curPage;
      this.getActionItem();
      this.scrollTop = 0;
    },
    // 搜索
    handleSearch() {
      this.searchForm.pageIndex = 1;
      this.getActionItem();
    },
    //点击筛选框
    switchPage(index, itemStatus) {
      this.clickIndex = index;
      this.searchForm.itemStatus = itemStatus;
      this.getActionItem();
      this.itemIdList = [];
      this.itemList = [];
      this.$refs.multipleTable.clearSelection();
    },
    //获取任务项数据
    getActionItem() {
      //1新装2加装3重装4开通5报停7以新换旧8套餐变更9转网10维修11巡检12拆卸
      if (this.taskType == 10) {
        //维修
        this.getRepairActionItem();
      } else if (this.taskType == 3) {
        //重装
        this.getReinstall();
      } else if (this.taskType == 12) {
        //拆卸
        this.getRemove();
      }
    },
    //获取维修任务单的任务项列表
    async getRepairActionItem() {
      try {
        this.loading = true;
        let res = await getRepairActionItem({
          taskId: this.taskId,
          ...this.searchForm
        });
        this.tableData = this.getFreezeResponse(res, {
          path: "data.array"
        });
        this.total = this.getFreezeResponse(res, {
          path: "data.totalRecords"
        });
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //获取重装任务单的任务项列表
    async getReinstall() {
      try {
        this.loading = true;
        let res = await getReinstallActionItem({
          taskId: this.taskId,
          ...this.searchForm
        });
        this.tableData = this.getFreezeResponse(res, {
          path: "data.array"
        });
        this.total = this.getFreezeResponse(res, {
          path: "data.totalRecords"
        });
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //获取拆卸任务单的任务项列表
    async getRemove() {
      try {
        this.loading = true;
        let res = await getRemoveTaskActionItem({
          taskId: this.taskId,
          ...this.searchForm
        });
        this.tableData = this.getFreezeResponse(res, {
          path: "data.array"
        });
        this.total = this.getFreezeResponse(res, {
          path: "data.totalRecords"
        });
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    // 获取页面操作权限
    getOperateList() {
      // 页面按钮权限
      let operates = [
        {
          label: "任务项详情",
          id: 1
        }
      ];
      if (this.taskType == 2) {
        operates.push({
          label: "查看已安装设备",
          id: 2
        });
      }
      return operates;
      // return this.filterOperateBtn(operates);
    },
    // 操作--更多
    handleOperate(val, row) {
      if (val.id == 1) {
        this.routerPush({
          name: "taskListManage/ActionItemDetail",
          params: {
            refresh: true,
            itemId: row.itemId
          }
        });
      } else {
        this.showEquipVisible = true;
      }
    },
    //关闭弹框
    handleClose(name) {
      this[name] = false;
      this.itemIdList = [];
      this.itemList = [];
      this.$refs.multipleTable.clearSelection();
    },
    //查看已安装设备弹框关闭
    closeDialog() {
      this.showEquipVisible = false;
    },
    /******选择物料*********/
    changeMaterial() {
      if (!this.basicInfo.isGrayscaleWork && this.itemIdList.length > 1) {
        this.$message.warning("只能勾选一个任务项");
        return;
      }
      if (!this.basicInfo.isGrayscaleWork && !this.itemIdList.length) {
        this.$message.warning("请先勾选一个任务项");
        return;
      }
      this.changeMaterialVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-table__expanded-cell {
  padding: 20px 0px;
}
</style>
